import { render, staticRenderFns } from "./GroupSection.vue?vue&type=template&id=7b9b3940"
import script from "./GroupSection.vue?vue&type=script&lang=js"
export * from "./GroupSection.vue?vue&type=script&lang=js"
import style0 from "./GroupSection.vue?vue&type=style&index=0&id=7b9b3940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports